import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './ui/global.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { theme } from './ui/theme';
import { App } from './app/App';
import { AccountProvider } from './features/account/AccountProvider';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <Notifications position="bottom-right" limit={3} />
      <AccountProvider>
        <App />
      </AccountProvider>
    </MantineProvider>
  </StrictMode>,
);
